import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrioritiesStatusEnum } from 'src/app/shared/enum/priorities-status.enum';
import { Priority } from 'src/app/shared/services/models/totem/priority.model';

@Component({
  selector: 'app-totem-priority-list',
  templateUrl: './totem-priority-list.component.html',
  styleUrls: ['./totem-priority-list.component.css']
})
export class TotemPriorityListComponent implements OnInit {

  @Input() listPriority: Array<Priority> = [];
  @Input() listTotemPriority: Array<Priority> = [];
  @Input() birthDate: Date | null = null;
  @Input() idGender: number | null = null;
  @Input() idGenderIdentity: number | null = null;
  @Input() isLoading: boolean = false;

  @Output() onPrint: EventEmitter<any> = new EventEmitter();
  @Output() onBack: EventEmitter<void> = new EventEmitter();

  private readonly GENDER_FEMININO = 3;
  private readonly GENDER_IDENTITY_HOMEM_TRANS = 2;

  prioritiesSelected: number[] = [];
  listFilteredTotemPriority: Array<Priority> = [];
  patientAge: number | null = null;

  public priorityAutism: PrioritiesStatusEnum = PrioritiesStatusEnum.AutistaTEA;
  public priorityBreastfeeding: PrioritiesStatusEnum = PrioritiesStatusEnum.lactante;

  constructor() { }

  ngOnInit(): void {
    this.listFilteredTotemPriority = JSON.parse(JSON.stringify(this.listTotemPriority));

    if (this.birthDate) {
      const age = this.getAge(this.birthDate);
      this.patientAge = age.years + age.months / 12;
    }

    const sourceList = this.listFilteredTotemPriority.length >= 1
      ? this.listFilteredTotemPriority
      : this.listPriority;
    sourceList.forEach(p => p.selected = false);

    this.listFilteredTotemPriority = this.listFilteredTotemPriority.filter(p =>
      this.shouldShowPriority(p)
    );

    setTimeout(() => {
      this.listFilteredTotemPriority.forEach(p => {
        if (this.shouldAutoSelect(p)) {
          const el = document.getElementById(p.idPriority!.toString());
          if (el) el.click();
        }
      });
    }, 500);
  }

  private get canBePregnantOrLactating(): boolean {
    return (
      this.idGender === this.GENDER_FEMININO ||
      this.idGenderIdentity === this.GENDER_IDENTITY_HOMEM_TRANS
    );
  }

  private shouldShowPriority(priority: Priority): boolean {
    const id = priority.idPriority;
    const age = this.patientAge;

    switch (id) {
      case PrioritiesStatusEnum.MaiorDe60Anos:
        // Exibe apenas se tiver 60 anos ou mais
        return age == null || age >= 60;

      case PrioritiesStatusEnum.MaiorDe80Anos:
        // Exibe apenas se tiver 80 anos ou mais
        return age == null || age >= 80;

      case PrioritiesStatusEnum.MenorDe1Ano:
        // Exibe apenas se tiver menos de 1 ano completo (0 a 11 meses e 29 dias)
        return age == null || age < 1;

      case PrioritiesStatusEnum.CriancaDeColo:
        // Exibe apenas se tiver menos de 2 anos
        return age == null || age < 2;

      case PrioritiesStatusEnum.DoadorDeSangue:
        // Exibe apenas para 16 a 69 anos (lei brasileira)
        return age == null || (age >= 16 && age < 70);

      case PrioritiesStatusEnum.GestanteGravida:
      case PrioritiesStatusEnum.lactante:
        // Sem info de gênero: exibe (permissivo)
        // Com info: apenas Feminino biológico ou Homem Trans
        return (
          (this.idGender == null && this.idGenderIdentity == null) ||
          this.canBePregnantOrLactating
        );

      default:
        // Autista, Desconforto, Obesidade, PCD, Deficiente Físico: sem restrição
        return true;
    }
  }

  private shouldAutoSelect(priority: Priority): boolean {
    const id = priority.idPriority;
    const age = this.patientAge;

    if (age == null) return false;

    switch (id) {
      case PrioritiesStatusEnum.MaiorDe80Anos:
        return age >= 80;
      case PrioritiesStatusEnum.MaiorDe60Anos:
        return age >= 60 && age < 80;
      case PrioritiesStatusEnum.MenorDe1Ano:
        return age < 1;
      default:
        return false;
    }
  }

  selectOption(selectedOption: Priority): void {
    const sourceList = this.listFilteredTotemPriority.length >= 1
      ? this.listFilteredTotemPriority
      : this.listPriority;

    sourceList.forEach(p => {
      if (p.idPriority === selectedOption.idPriority) {
        p.selected = !p.selected;
      }
    });
  }

  back(): void {
    if (this.isLoading) return;
    this.onBack.emit();
  }

  print(): void {
    if (this.isLoading) return;

    this.isLoading = true;

    const sourceList = this.listFilteredTotemPriority.length >= 1
      ? this.listFilteredTotemPriority
      : this.listPriority;

    this.prioritiesSelected = sourceList
      .filter(p => p.selected && p.idPriority != null)
      .map(p => p.idPriority!);

    sourceList.forEach(p => p.selected = false);

    this.onPrint.emit(this.prioritiesSelected);
  }

  getAge(birthDate: Date): { years: number; months: number; days: number } {
    let dob = new Date(birthDate);
    const daysInMonth = 30.436875;
    let now = new Date();
    let yearNow = now.getFullYear();
    let yearDob = dob.getFullYear();
    let years = yearNow - yearDob;

    dob.setFullYear(yearNow);
    let nowMillis = now.getTime();
    let dobMillis = dob.getTime();
    if (nowMillis < dobMillis) {
      --years;
      dob.setFullYear(yearNow - 1);
      dobMillis = dob.getTime();
    }
    let days = (nowMillis - dobMillis) / 86400000;
    let monthsDec = days / daysInMonth;
    let months = Math.floor(monthsDec);
    days = Math.floor(daysInMonth * (monthsDec - months));
    return { years, months, days };
  }
}